import { asyncEpicStandard } from 'src/logic/helpers/epics/async.epic-helper';
import { apiConfigurationAsync } from './api-configuration.actions';

export const apiConfigurationEpic = asyncEpicStandard(apiConfigurationAsync, ({ api }) =>
    api.apiConfiguration.all()
);
